
namespace Gamification.Gamification {
    export class UtentiProdottiConProprietaColumns {
        static columnsKey = 'Gamification.UtentiProdottiConProprieta';
    }
}